// Bootstrap 4 JS is loaded once, globally, by bootstrap.bundle.min.js (includes/partials/jquery),
// like jQuery (see jquery-global.js). vite.config.mjs points JS imports of "bootstrap" here: the npm
// package would evaluate a second copy that registers every jQuery plugin and data-api handler
// again, and a dropdown then opens and closes on the same click.
const bootstrap = window.bootstrap;

if (!bootstrap) {
  throw new Error('bootstrap.bundle.min.js must be loaded before application scripts');
}

export const {
  Alert, Button, Carousel, Collapse, Dropdown, Modal, Popover, Scrollspy, Tab, Toast, Tooltip, Util,
} = bootstrap;

export default bootstrap;
